import React, { useEffect, useState } from "react";
import { useLanguageContext } from "../Context/LanguageContext";

import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";

const tableStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    display: "flex",

    // justifyContent: "space-between",
  },
  MuiInputAdornmentRoot: {
    borderBottom: "1px solid #ccc",
    marginBottom: "10px",
  },
  tableContainer: {
    maxHeight: 400,
    overflowY: "auto",
  },
  tableRow: {
    backgroundColor: "#ccedff",
  },
  tableRowStyle: {
    cursor: "pointer",
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    fontSize: "14px",
  },
}));
export default function EquipmentTagIssuePopover({
  equipmentTagIssueList,
  typeReport,
  handleClosePopOverTagIssue,
  equipmentGrpName,
}) {
  const classes = tableStyles();
  const { localization } = useLanguageContext();
  const [itemList, setItemList] = useState(null);
  const [detailList, setDetailList] = useState(null);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  useEffect(() => {
    if (equipmentTagIssueList) {
      setItemList(itemList);
      setSelectedEquipment(equipmentTagIssueList[0]);
      setItemList(equipmentTagIssueList);
    }
  }, [equipmentTagIssueList]);

  function handleClosePopOver() {
    setItemList([]);
    setDetailList(null);
    setSearchValue("");
    handleClosePopOverTagIssue();
  }

  const onSearchChange = (value) => {
    setSearchValue(value.trim());
    const filtered = equipmentTagIssueList.filter(
      (row) =>
        row.inventarNr.trim().toLowerCase().includes(value.trim().toLowerCase())
      // Object.values(row).some((val) =>
      //   String(val).toLowerCase().includes(value.toLowerCase())
      // )
    );

    setItemList(filtered);
    setSelectedEquipment(filtered[0]);
  };
  return (
    <div
      className="modal fade nestedPopover"
      id="tagIssue"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="tagIssue"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog nestedPopverMargin" role="document">
        <div className="modal-content tableWidth">
          <div className="modal-header">
            <h5 className="modal-title" id="tagIssue">
              {typeReport === "missing"
                ? localization.Equipmentmissingtag
                : typeReport === "duplicate"
                ? localization.Equipmentduplicatetag
                : ""}
            </h5>

            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="TicketDetailsModalClose"
              onClick={handleClosePopOver}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div
                id="tagIssueSearch"
                className={classes.root + " " + "col-6 flex-column"}
              >
                <InputBase
                  placeholder={localization.search}
                  classes={{
                    root: classes.inputRoot,
                    input: classes.inputInput,
                  }}
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  }
                  value={searchValue}
                  inputProps={{ "aria-label": "search" }}
                  onChange={(e) => {
                    onSearchChange(e.target.value);
                  }}
                />

                <TableContainer
                  component={Paper}
                  className={classes.tableContainer}
                >
                  <Table aria-label="collapsible table">
                    <TableHead>
                      <TableRow>
                        {/* {tableHeaders.map((item, index) => ( */}
                        <TableCell align="left">
                          {localization.inventanrnr}
                        </TableCell>
                        {/* ))} */}
                      </TableRow>
                    </TableHead>
                    {itemList && (
                      <TableBody>
                        {itemList.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={6} align="center">
                              {localization.noRecordFound}
                            </TableCell>
                          </TableRow>
                        ) : (
                          itemList.map((row, index) => (
                            <TableRow
                              onClick={() => {
                                setSelectedEquipment(row);
                              }}
                              className={`${classes.tableRowStyle} ${
                                selectedEquipment?.id === row.id
                                  ? "selectedRow"
                                  : ""
                              }`}
                              key={index}
                            >
                              <TableCell>{row.inventarNr}</TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </div>
              <div className="col-6">
                {selectedEquipment && (
                  <>
                    <h2>{localization.equipDetails}</h2>

                    <div className="row p-3">
                      <div className="col">{localization.tag}</div>
                      <div className="col">{selectedEquipment.tag}</div>
                    </div>
                    <div className="row p-3">
                      <div className="col">{localization.eqGrp}</div>
                      <div className="col">
                        {equipmentGrpName +
                          " (" +
                          selectedEquipment.anlagegruppeId +
                          ")"}
                      </div>
                    </div>
                    <div className="row p-3">
                      <div className="col">{localization.costCenter}</div>
                      <div className="col">
                        {selectedEquipment.kostenstelle}
                      </div>
                    </div>
                    <div className="row p-3">
                      <div className="col">{localization.status}</div>
                      <div className="col"> {selectedEquipment.status}</div>
                    </div>
                    <div className="row p-3">
                      <div className="col">{localization.nextCheckDate}</div>
                      <div className="col">
                        {" "}
                        {selectedEquipment.naechstePruefungDisplay}
                      </div>
                    </div>
                    <div className="row p-3">
                      <div className="col">{localization.lastCheckDate}</div>
                      <div className="col">
                        {" "}
                        {selectedEquipment.letztePruefungDisplay}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="modal-footer"></div>
        </div>
      </div>
    </div>
  );
}
